import axios from "axios"
import qs from "qs"

const getBaseUrl = (env, url) => {
    env = process.env.MODE_ENV || env
    let base = {
        production: 'https://api2.bjmeishu.com/',
        pre: 'https://preapi2.bjmeishu.com/',
        // development: 'https://preapi2.bjmeishu.com/',
        development: 'https://preapi2.bjmeishu.com/',
    }[env];
    return base
};

class NewAxios {
    constructor() {
        this.timeout = 20000
        this.withCredentials = false
    }

    setInterceptors = (instance, url) => {
        instance.interceptors.request.use((config) => {
            if (config.method.toLocaleLowerCase() === 'get') {

                let urlAppend = '?';
                Object.keys(config.data).forEach(key => {
                    urlAppend += `${key}=${config.data[key]}&`;
                });
                urlAppend = urlAppend.substr(0, urlAppend.length - 1);
                config.url += urlAppend;
            }
            if (config.method.toLocaleLowerCase() === 'post') {
                config.data = qs.stringify(config.data);
            }
            if (config.header) {
                for(let key in config.header) {
                    config.headers[key] = config.header[key]
                }
            }
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

            // config.headers['Authorization'] = localStorage.getItem('auth') ? 'bearer ' + localStorage.getItem('auth') : ''
            return config;
        }, err => Promise.reject(err));

        instance.interceptors.response.use(
            (response) => {
                if (response.headers && response.headers.Location) {
                    window.location.href = response.headers.Location
                }
                // 在这里移除loading
                // todo: 想根据业务需要，对响应结果预先处理的，都放在这里
                if (response.status === 200) {
                    return response.data
                }
                return response.data
            },
            (err) => {
                console.log("err", err)
                if (err.response) {
                    // 响应错误码处理
                    const data = {
                        status: err.response.status,
                        msg: "",
                    }
                    switch (err.response.status) {
                        case "403":
                            data.msg = "权限不足，请联系管理员"
                            break
                        case "401":
                            data.msg = "登录过期，请重新登录"
                            break
                        case "500":
                            data.msg = "服务器错误，请重试"
                            break
                        default:
                            data.msg = "服务器繁忙，请重试"
                            break
                    }
                    return data
                }
                if (!window.navigator.online) {
                    // 断网处理
                    const data = {
                        status: -1,
                        msg: "网络错误，请重试",
                    }
                    return data
                }
                return Promise.reject(err)
            }
        )
    }

    request (options) {
        // 每次请求都会创建新的axios实例。
        const instance = axios.create()
        const config = {
            // 将用户传过来的参数与公共配置合并。
            ...options,
            baseURL: getBaseUrl(process.env.NODE_ENV, options.url),
            timeout: this.timeout,
            withCredentials: this.withCredentials,
        }
        // 配置拦截器，支持根据不同url配置不同的拦截器。
        this.setInterceptors(instance, options.url)
        return instance(config) // 返回axios实例的执行结果
    }
}

export default new NewAxios()
